<template>
    <div>
        <b-row v-show="mostrarDetalhesContrato">
            <b-col sm="12">
                <b-card no-body>
                    <b-card-header>
                        <div class="h5" v-if="contrato">
                            {{ contrato.codContrato }}

                            <div class="float-right">
                                <button
                                v-if="mostrarBtnVoltarListaContratos"
                                class="btn btn-danger"
                                @click.stop="voltarListaContratos()">
                                    <i class="fa fa-arrow-left mr-2"></i>Voltar para lista de contratos
                                </button>

                                <button
                                v-if="mostrarBtnVoltarDetalhesContrato"
                                class="btn btn-danger"
                                @click.stop="voltarDetalhesContrato()">
                                    <i class="fa fa-arrow-left mr-2"></i>Voltar para detalhes do contrato
                                </button>
                            </div>
                        </div>
                    </b-card-header>
                    <b-card-body>
                        <div v-if="contrato">
                            <app-k-v
                                titulo="Objeto"
                                :md="3"
                                :lg="2"
                                :xl="1"
                                :dado="contrato.objeto"
                            ></app-k-v>
                            <app-k-v
                                titulo="Numero da Licitacao"
                                :md="3"
                                :lg="2"
                                :xl="1"
                                :dado="contrato.numeroLicitacao"
                            ></app-k-v>
                            <app-k-v titulo="Vigência" :md="3" :lg="2" :xl="1"
                                ><strong
                                    >{{
                                        $moment(contrato.inicioVigencia).format(
                                            'DD/MM/YYYY'
                                        )
                                    }}
                                    -
                                    {{
                                        $moment(contrato.fimVigencia).format(
                                            'DD/MM/YYYY'
                                        )
                                    }}</strong
                                ></app-k-v
                            >
                            <app-k-v
                                titulo="Valor Total"
                                :md="3"
                                :lg="2"
                                :xl="1"
                                ><strong>{{
                                    contrato.valorTotal | currency
                                }}</strong></app-k-v
                            >
                            <!-- <app-k-v titulo="Saldo" :md="3" :lg="2" :xl="1"
                                ><strong>{{
                                    contrato.saldo | currency
                                }}</strong></app-k-v
                            > -->
                            <app-k-v
                                titulo="Gestor"
                                :md="3"
                                :lg="2"
                                :xl="1"
                                :dado="contrato.gestor"
                            ></app-k-v>
                            <app-k-v titulo="Status" :md="3" :lg="2" :xl="1"
                                ><app-status
                                    class="badge-status-contrato"
                                    :status="contrato.status"
                                ></app-status
                            ></app-k-v>
                            <app-k-v
                                v-if="numeroAditivoVigente"
                                titulo="Nº Aditivo Vigente"
                                :md="3"
                                :lg="2"
                                :xl="1"
                                ><strong>{{ numeroAditivoVigente }}</strong></app-k-v
                            >
                        </div>
                    </b-card-body>
                    <b-card-footer v-if="mostrarOpcaoConfiguracaoBoletim">
                        <button
                            class="btn btn-primary"
                            @click="abrirGestaoBoletim"
                        >
                            <i class="fa fa-cog mr-2"></i>
                            Gestão do Boletim
                        </button>
                    </b-card-footer>
                </b-card>
            </b-col>
        </b-row>
        <contratos-dashboard
            v-if="mostrarDashboardContrato"
        ></contratos-dashboard>
        <router-view
            v-if="contrato"
            :contrato="contrato"
            :dataServico="dataServico"
        ></router-view>
    </div>
</template>

<script>
import ContratosDashboard from './ContratosDash2'
import ContratosServicos from '../../fornecedor/contratos/ContratosServicos'
import { numeroAditivoVigente } from '../../fornecedor/contratos/boletinsMedicoes/historicoAditivosUtils'

export default {
    props: {
        contratos: {
            type: Array,
            default: () => []
        },

        dataServico: {
            type: Object,
            default: () => {}
        }
    },

    components: { ContratosDashboard },

    data() {
        return {
            erros: [],
            historicoAditivos: []
        }
    },

    methods: {
        voltarListaContratos() {
            if (this.$route.name != 'FornecedoresContratos_Detalhar') {
                this.$router.push({ name: 'FornecedorContratos' })
            } else {
                this.$router.push({ name: 'FornecedoresContratos' })
            }
        },

        voltarDetalhesContrato (){
            this.$router.push({
                name: 'FornecedorContratos_Detalhar',
                params: { codContrato: this.$route.params.codContrato }
            })
        },

        abrirGestaoBoletim() {
            this.$router.push({
                name: 'FornecedorContratos_BoletimGestao',
                params: { codContrato: this.$route.params.codContrato }
            })
        },

        obterHistoricoAditivos(contratoId) {
            ContratosServicos.obterHistoricoAditivos(contratoId)
                .then(response => {
                    if (response && response.success && response.data) {
                        this.historicoAditivos = response.data
                    }
                })
        }
    },

    computed: {
        contrato() {
            const contrato = this.contratos.find(
                c => c.codContrato === this.$route.params.codContrato.replaceAll('-', '/')
            )

            if (contrato && Array.isArray(contrato.responsaveisContrato)) {
                // adicionando atributos dinamicos para representar as responsabilidades do usuario do contrato
                contrato.usuarioEhFiscalObra = contrato.responsaveisContrato.some(
                    item => item.idFuncionarioRm === this.$store.getters.usuario.chapa &&
                    item.tipoResponsavelContrato.codigoRM == 'GESCON_01'
                );
                contrato.usuarioEhCadastrador = contrato.responsaveisContrato.some(
                    item => item.idFuncionarioRm === this.$store.getters.usuario.chapa &&
                    item.tipoResponsavelContrato.codigoRM == 'GESCON_02'
                );
                contrato.usuarioEhGestorContratos = contrato.responsaveisContrato.some(
                    item => item.idFuncionarioRm === this.$store.getters.usuario.chapa &&
                    item.tipoResponsavelContrato.codigoRM == 'GESCON_03'
                );
                contrato.usuarioEhOrdenador = contrato.responsaveisContrato.some(
                    item => item.idFuncionarioRm === this.$store.getters.usuario.chapa &&
                    item.tipoResponsavelContrato.codigoRM == 'GESCON_04'
                );
            }

            return contrato
        },

        isRotaContratosDetalhar() {
            return (
                this.$route.name === 'FornecedoresContratos_Detalhar' ||
                this.$route.name === 'FornecedorContratos_Detalhar'
            )
        },

        mostrarDashboardContrato() {
            return this.isRotaContratosDetalhar
        },

        mostrarBtnVoltarListaContratos() {
            return this.isRotaContratosDetalhar
        },

        mostrarBtnVoltarDetalhesContrato() {
            return this.$route.name === 'FornecedorContratos_BoletinsMedicoes'
        },

        mostrarDetalhesContrato() {
            return (
                this.$route.name === 'FornecedoresContratos_Detalhar' ||
                this.$route.name === 'FornecedorContratos_Detalhar' ||
                this.$route.name === 'FornecedorContratos_BoletinsMedicoes' ||
                this.$route.name === 'FornecedorContratos_BoletimGestao'
            )
        },

        mostrarOpcaoConfiguracaoBoletim() {
            return (
                this.$route.name === 'FornecedorContratos_BoletinsMedicoes'
                && this.contrato
                && (
                    this.contrato.usuarioEhGestorContratos
                    || this.contrato.usuarioEhOrdenador
                    || this.$store.getters.isFornecedor
                )
            )
        },

        numeroAditivoVigente() {
            return numeroAditivoVigente(this.historicoAditivos)
        }

    },

    created() {},

    watch: {
        contrato: {
            immediate: true,
            handler(novoContrato) {
                if (novoContrato && novoContrato.contratoId) {
                    this.obterHistoricoAditivos(novoContrato.contratoId)
                }
            }
        }
    }
}
</script>

<style scoped>
::v-deep .badge-status-contrato .badge {
    font-size: 0.875rem;
    font-weight: 700;
    text-transform: uppercase;
}
</style>
